(function(){
    'use strict';
    angular.module('Directives').directive('formError', formError);
    
    formError.$inject = [];

    function formError() {
        return {
            'restrict' : 'E',
            templateUrl: '/templates/directives/formError.html',
            'scope' : {
                error: '=?'
            },
            'link' : formErrorLink
        }

        function formErrorLink($scope) {

        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/formError.js